import React from 'react';
import { useFadeUp } from '../../shared/useFadeUp';
import './comparison.css';

const BEFORE = [
  'Scroll through a comment library for each finding',
  'Update templates across 50+ sections',
  '8–10 steps per finding',
  '2–4 hours of report writing at night',
];

const AFTER = [
  'Photos & voice note, generated in seconds',
  'Upload once — Morph keeps your style consistent',
  '3 steps — snap, speak, move on',
  'Report done before you leave the property',
];

const Comparison: React.FC = () => {
  const before = useFadeUp<HTMLDivElement>({ threshold: 0.2 });
  const after = useFadeUp<HTMLDivElement>({ threshold: 0.2 });

  return (
    <section className="v2-comp" id="comparison">
      <div className="v2-comp__glow" />
      <div className="v2-comp__container">
        <div
          ref={before.ref}
          className={`v2-comp__col v2-comp__col--before ${before.isVisible ? 'is-visible' : ''}`}
        >
          <h3 className="ui-eyebrow v2-comp__heading">Traditional workflow</h3>
          {BEFORE.map((row, i) => (
            <div
              key={row}
              className="v2-comp__row"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              {row}
            </div>
          ))}
        </div>
        <div
          ref={after.ref}
          className={`v2-comp__col v2-comp__col--after ${after.isVisible ? 'is-visible' : ''}`}
        >
          <h3 className="ui-eyebrow v2-comp__heading v2-comp__heading--accent">
            With Morph
          </h3>
          {AFTER.map((row, i) => (
            <div
              key={row}
              className="v2-comp__row"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              {row}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Comparison;
